export const uk = {
    'ad-group-bad-geo-for-belarusian':
        'Регион показа не может быть изменён, так как текст объявления {bannerId} на белорусском языке. Показы возможны только в Беларуси.',
    'ad-group-bad-geo-for-default': 'Язык объявления {bannerId} не соответствует выбранному региону показа.',
    'ad-group-bad-geo-for-kazakh':
        'Регион показа не может быть изменён, так как текст объявления {bannerId} на казахском языке. Показы возможны только в Казахстане.',
    'ad-group-bad-geo-for-turkish':
        'Регион показа не может быть изменён, так как текст объявления {bannerId} на турецком языке. Показы возможны только в Турции.',
    'ad-group-bad-geo-for-ukraine':
        'Регион показа не может быть изменён, так как текст объявления {bannerId} на украинском языке. Показы возможны только в Украине.',
    'default-error': 'Неизвестная ошибка: {codeError}',
    'general-rate-required': 'Укажите ставку для новых условий',
    'geo-empty-regions': 'Выберите регионы показа',
    'geo-ids-incorrect-regions': 'Указан несуществующий регион: {regionIds}',
    'geo-minus-region-matches-plus-region':
        'Неверный формат, исключаемый регион {minusRegionIds} не может вычитать регион показа {regionIds}',
    'geo-minus-regions-without-plus-regions':
        'В исключении присутствуют регионы, не содержащиеся ни в одном из регионов показа: {regionIds}',
    'geo-no-plus-regions': 'Отсутствуют регионы показа',
    'incorrect-goal-id': 'Указана некорректная цель',
    'invalid-max-value-level': 'Значение не может быть больше {max}',
    'key-words-limit': 'Превышен лимит в {count} ключевых фраз',
    'library-list-minus-keywords-max': 'Максимальное количество привязанных наборов: {maxSize}',
    'library-list-minus-keywords-object-not-found': 'Вы выбрали набор, который был удален',
    'max-groups-in-campaign': 'Достигнут максимум групп в кампании',
    'max-retargetings-size': {
        one: 'Можно выбрать не более {count} условия',
        some: 'Можно выбрать не более {count} условий',
        many: 'Можно выбрать не более {count} условий',
        none: 'Можно выбрать не более {count} условий'
    },
    'minus-keywords-max-length':
        'Превышена допустимая длина слова в минус-фразе в {maxLength} символов. Ошибки во фразах: {minusWords}',
    'name-empty': 'Не указано название группы',
    'name-max-length': 'Название группы не может быть длиннее {maxLength} символов',
    'name-prohibited-symbols': 'Название группы содержит запрещенные символы',
    'page-blocks-are-required': 'Необходимо указать рекламные поверхности',
    'phrase-cannot-be-empty': 'Ключевая фраза не может быть пустой',
    'phrase-illegal-characters':
        'В тексте ключевых фраз разрешается использовать только буквы английского, турецкого, казахского, русского, украинского или белорусского алфавита, кавычки, знаки «-», «+», «!», пробел. Ошибка в ключевой фразе: {phrase}',
    'phrase-incorrect-use-of-parenthesis':
        'Ошибка в использовании оператора, возможно, использованы непарные скобки в ключевой фразе: {phrase}',
    'phrase-invalid-apostrophe': "Неправильное использование знака «'» в ключевой фразе: {phrase}",
    'phrase-invalid-brackets': 'Неправильное использование скобок [] в ключевой фразе: {phrase}',
    'phrase-invalid-exclamation-mark': 'Неправильное использование знака «!» в ключевой фразе: {phrase}',
    'phrase-invalid-minus-mark': 'Неправильное использование знака «-» в ключевой фразе: {phrase}',
    'phrase-invalid-plus-mark': 'Неправильное использование знака «+» в ключевой фразе: {phrase}',
    'phrase-invalid-point': 'Неправильное сочетание специальных символов в ключевой фразе: {phrase}',
    'phrase-invalid-quotes': 'Неправильное использование кавычек в ключевой фразе: {phrase}',
    'phrase-minus-keywords-max-length': 'Превышена допустимая длина минус-слова "{minusWord}" в {maxLength} символов.',
    'phrase-minus-word-delete-plus-word':
        'Нельзя вычитать слово — ({word}), содержащееся в исходной ключевой фразе: {phrase}',
    'phrase-minus-word-inside-brackets-or-quotes':
        'Минус-слова не могут быть в кавычках или квадратных скобках. Ошибка в ключевой фразе: {phrase}',
    'phrase-no-plus-words': 'Ключевая фраза не может состоять только из минус-слов',
    'phrase-not-single-minus-word':
        'Из ключевой фразы могут вычитаться только отдельные слова, а не словосочетания: {phrase}',
    'phrase-only-stop-words':
        'Ключевая фраза не может состоять только из стоп-слов (союзов, предлогов, частиц): {phrase}',
    'phrase-plus-mark-in-brackets':
        'Знак «+» не может использоваться в квадратных скобках. Ошибка в ключевой фразе: {phrase}',
    'phrase-too-long-keyword': 'Превышена допустимая длина строки в {maxLength} символов в ключевой фразе: {phrase}',
    'phrase-too-long-word':
        'Превышена допустимая длина отдельного ключевого слова в {maxLength} символов. Ошибки в словах: {word}',
    'phrase-too-many-words': 'Ключевая фраза не может состоять более чем из {maxWords} слов. Ошибки во фразе: {phrase}',
    'phrases-cannot-be-empty': 'Необходимо задать ключевые фразы',
    'retargeting-condition-cannot-be-empty': 'Необходимо задать условие показа',
    'retargeting-condition-name-cannot-be-empty': 'Укажите название аудитории',
    'retargeting-condition-not-found': 'Одно из выбранных условий было удалено',
    'retargeting-condition-only-symbols':
        'В названии условия допускается использование только букв латинского, турецкого, русского, украинского, казахского алфавитов, цифр и знаков пунктуации.',
    'retargeting-conditions-name-max-length': 'Длина названия не должна превышать {maxLength} символов',
    'tags-duplicated-error': 'Теги должны быть уникальными',
    'tags-invalid-value': 'Тег должен содержать только латинские символы, цифры, нижнее подчеркивание, тире',
    'tags-keyword-length-max': {
        one: 'Максимальная длина тега: {maxLength} символ',
        some: 'Максимальная длина тега: {maxLength} символа',
        many: 'Максимальная длина тега: {maxLength} символов',
        none: 'Максимальная длина тега: {maxLength} символов'
    },
    'tags-keywords-max': 'Максимальное количество привязанных тегов: {maxSize}',
    'test-page-error': 'Возникла ошибка. Откройте карту с рекламными площадками и нажмите «Сохранить»',
    'too-wide-geotargeting-smart': 'Геотаргетинг группы шире списка стран её смарт-баннеров',
    'yandexuids-cannot-be-empty': 'Поле не может быть пустым',
    'yandexuids-invalid-value': 'Неверное значение (введите значения из 17-19 цифр)'
};
